import { render, staticRenderFns } from "./LanguageDropdown.vue?vue&type=template&id=0ae6af8c&"
import script from "./LanguageDropdown.vue?vue&type=script&lang=js&"
export * from "./LanguageDropdown.vue?vue&type=script&lang=js&"
import style0 from "./LanguageDropdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LanguageDropdown.vue"
export default component.exports